export default "__VITE_ASSET__BEjtEejv__"